import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const Projects = () => {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    axios.get(`${API_URL}/api/projects`)
  .then((response) => setProjects(response.data))
  .catch((error) => console.error('Error fetching projects:', error));
  }, []);

  return (
    <section className="p-10">
      <h2 className="text-4xl font-bold mb-5">Projects</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {projects.map((project) => (
          <div key={project._id} className="p-5 bg-white shadow-lg rounded-lg">
            <h3 className="text-xl font-bold">{project.title}</h3>
            <p>{project.description}</p>
            <a href={project.url} className="text-blue-500">Visit Project</a>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Projects;
